/* eslint-disable import/no-cycle */
import React, { memo } from "react";

import { Box, Preloader, Stack, Text } from "@origin-digital/ods-core";

import { RouterActions, StyledHeading, StyledQuestion } from "@/components";
import { SolarBatteryOutlookWrapper } from "./SolarBatteryOutlookWrapper";
import { useSolarBatteryOutlook } from "./useSolarBatteryOutlook";
import { useFieldValidation } from "@/hooks";
import { useMediaQuery, useTheme } from "@mui/material";
import { solarBatteryOutlook as content } from "./content.json";

export const SolarBatteryOutlook = memo(
  ({
    backRoute,
    nextRoute,
    hardStopRoute,
  }: {
    backRoute: () => Promise<string>;
    nextRoute: () => Promise<string>;
    hardStopRoute: () => Promise<string>;
  }) => {
    const { loading, solarBatteryOutlook, medianSizeIndex } =
      useSolarBatteryOutlook({
        hardStopRoute,
      });

    const { isValid } = useFieldValidation({ fields: ["selectedSystemSize"] });

    const theme = useTheme();
    const isMdDown = useMediaQuery(theme.breakpoints.down("md")); // Check the viewport width is below md = 768px

    let headline = "";
    let subHeadline = "";
    if (solarBatteryOutlook.length) {
      if (solarBatteryOutlook.length === 1) {
        const solarSize = solarBatteryOutlook[0].size;
        const minSolarSize = 4;
        const maxRangeForSmallSolar = 5;
        if (
          solarSize &&
          solarSize >= minSolarSize &&
          solarSize < maxRangeForSmallSolar
        ) {
          headline = content.recommendation.headlineMessage4WSolar;
          subHeadline = content.recommendation.subHeadlineMessage4WSolar;
        }
      } else {
        headline = content.recommendation.headlineMessageAllSolar;
        subHeadline = content.recommendation.subHeaderMessageAllSolar;
      }
    }

    return (
      <StyledQuestion>
        <div>
          <StyledHeading data-id={content.recommendation.id} tone="primaryB">
            {content.recommendation.heading}
          </StyledHeading>
          <Stack space="medium">
            <Text tone="neutralDark">{headline}</Text>
            <Text tone="neutralDark">{subHeadline}</Text>
          </Stack>
          <br />
          {loading ? (
            <Box
              data-id="preloader-wrapper"
              display="flex"
              alignItems="center"
              justifyContent="center"
              style={{ height: "50vh" }}
            >
              <Preloader />
            </Box>
          ) : (
            <>
              <SolarBatteryOutlookWrapper
                medianSizeIndex={medianSizeIndex}
                solarBatteryOutlook={solarBatteryOutlook}
              />
              <RouterActions
                nextLabel={
                  isMdDown
                    ? content.recommendation.nextLabel
                    : content.recommendation.next
                }
                onBackRoute={backRoute}
                onNextRoute={nextRoute}
                onNext={isValid}
              />
            </>
          )}
        </div>
      </StyledQuestion>
    );
  }
);
